<template>
<div>
  <div
    v-bind:class="{'dropzone': true, 'dropping': dropping, 'is-hidden-touch': true}"
    v-on:dragover="allowDrop"
    v-on:dragout="stopDrop"
    v-on:drop="onDrop"
    style="height: 200px; width: 100%; border: 1px solid black;"
  >
    <span v-if="!dropping">Drag images here</span>
    <span v-if="dropping">Okay, now drop the images</span>
  </div>
  <div class="file is-hidden-desktop">
  <label class="file-label">
    <input class="file-input" type="file" name="resume" multiple accept="image/jpeg" v-on:change="onInputChange">
    <span class="file-cta">
      <span class="file-icon">
        <i class="im im-upload"></i>
      </span>
      <span class="file-label">
        Choose files…
      </span>
    </span>
  </label>
</div>
</div>
</template>

<script>
export default {
  computed: {},
  data() {
    return {
      totalFiles: 0,
      files: {},
      dropping: false
    };
  },
  methods: {
    allowDrop(e) {
      this.dropping = true;
      e.preventDefault();
    },
    stopDrop() {
      this.dropping = false;
    },
    onInputChange(e) {
      console.log(e.target.files)
      this.$store.dispatch("uploadFiles/handleFileObjects", e.target.files)
    },
    onDrop(e) {
      e.preventDefault();
      this.dropping = false;
      if (e.dataTransfer.items) {
        // Use DataTransferItemList interface to access the file(s)
        
        this.$store.dispatch("uploadFiles/addUploadFilesDrag",{
          webkitFolders: e.dataTransfer.items
        });
        this.$router.push("/upload");
      }
    }
  }
};
</script>
